import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
    background: #f4f4f4;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    border: 1px solid ${colors.platinum};
  `,
  button: css`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 0px !important;
  `,
  optionMenu: css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  `,
  optionText: css`
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  filterButton: css`
    padding: 2px 8px;
    border-radius: 10px;
    border: 1px solid ${colors.prussian400};
  `,
  menuItem: css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    cursor: pointer;

    &:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-focusVisible:not(.Mui-selected),
    &:focus-visible:not(.Mui-selected) {
      background-color: transparent !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }

    &.Mui-selected {
      background-color: ${colors.platinum} !important;
      border-left: 3px solid ${colors.jungle};
      padding-left: 13px;
    }

    &.Mui-selected:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-selected.Mui-focusVisible,
    &.Mui-selected:focus-visible {
      background-color: ${colors.platinum} !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }
  `,
  activeOption: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      max-width: 198px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  popper: css`
    max-width: 262px;
    margin-top: 6px !important;
  `,
  buttonWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
  `,
  tagFilter: css`
    width: 52px;
    justify-content: center;
  `,
  badge: css`
    background: ${colors.white};
    color: ${colors.jungle};
    border-radius: 50%;
    height: 14px;
    width: 14px;
    text-align: center;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: -0.3px;
  `,
};

export default styles;
